import { IGrants } from '@app/models';

export const maxExpiryDate: string = '9999-12-31T23:59:59.9999999Z';
export const TRUSTED_DEVICE_NAME = 'TrustedDevice';

export function numberOfDevices(grants: IGrants[]) : number {
    if (grants === undefined || !grants.length) {
        return 0;
    }

    let count: number = 0;

    grants.forEach(function (grant: IGrants) {
        if (isValidTrustedDevice(grant)) {
            count++;
        }
    });

    return count;
}

export function isValidTrustedDevice(grant: IGrants) : boolean {
    if (grant.Type === TRUSTED_DEVICE_NAME) {
        return true;
    }
    else {
        return false;
    }
}
